// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__17TrH","title":"Info_title__1ME0i","selects":"Info_selects__2ixlM","requiredAsterisk":"Info_requiredAsterisk__3GW5-"};